import React, { Component } from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

const headerData = [
    {
        id: 'date',
        title: '일자'
    },
    {
        id: 'start',
        title: '시간'
    },
    {
        id: 'chname',
        title: '채널명'
    },
    {
        id: 'category',
        title: '카테고리'
    },
    {
        id: 'title',
        title: '제목'
    },
    {
        id: 'desc',
        title: '비고'
    },
];

class ContentContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
        };
    }
    componentDidMount(){
        const {getEpgInfo, selectedDate} = this.props;
        getEpgInfo(selectedDate);
    }
    render() {
        const {scheduleList} = this.props;
        return (
            <div className="list-container">
              {scheduleList.length > 0 &&
                <div className="list-wrap">
                <table className="list">
                  <thead>
                    <tr className="header">
                        {headerData.map(th => {
                            return <th key={`th_${th.id}`} className={th.id}>{th.title}</th>;
                            }
                        )}
                    </tr>
                  </thead>
                  <tbody>
                  {scheduleList.map(item => 
                            <ListContainer item={item} 
                              key={`item_${item.num}`} 
                            />
                        )}
                        </tbody>
                    </table>
                </div>
              }
            </div>
       
        
        );
    }
}

const ListContainer = ({item}) => {
    return (
        <tr className="body">
            {headerData.map((data, idx)=>
            (
                <List 
                    key={idx}
                    item={item}
                    data={data}
                    idx={idx}
                />
            )
            )}
        </tr>
    )
}

const List = ({data, item, idx}) => {
    const getTime = (start, stop) => {
        const sTime = moment(start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        const eTime = moment(stop, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        return `${sTime} ~ ${eTime}`;
    }
    const typeValue = (type) => {
        switch(type){
        case "start":
            return getTime(item.start, item.stop);
        default:
            return item[type];
        }
    }
    return <td key={`td_${data.id}${idx}`} className={data.id}>{typeValue(data.id)}</td>;
}


const mapStateToProps = (state) => {
    return {
      selectedDate: state.selectedDate,
    }
  };
  
ContentContainer = connect(mapStateToProps)(ContentContainer);


export default ContentContainer;


// WEBPACK FOOTER //
// ./src/containers/schedule/TextMode/ContentContainer.js